export default "__VITE_ASSET__zXkd1ZjK__"